import React from 'react';
import { Gift } from 'lucide-react';
const mangoDiamond = require("../assets/mango_diamond.png");

export const Header = ({ userName, coinBalance, expiryDate, phoneNumber }) => {
  return (
    <div
      className="relative text-black p-6 rounded-b-3xl"
      style={{
        backgroundImage: `url(${mangoDiamond})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: 150
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent rounded-b-3xl"></div>
      <div className="max-w-md mx-auto">
        <div className="flex items-center justify-between mb-2">
          <h1 className="text-1.5xl font-bold">Hello {userName}</h1>
          {phoneNumber && (
            <div className="bg-black bg-opacity-40 px-3 py-1 rounded-full">
              <span className="text-white text-sm">{phoneNumber}</span>
            </div>
          )}
        </div>
        {/* <p className="text-black mb-6 font-weight text-lg">
          You have <span className="text-orange-400 font-semibold">{coinBalance} Aaladipattiyan Coins</span>{' '}
          <span className="text-sm">({expiryDate})</span>
        </p> */}

        {/* <button className="bg-white text-gray-900 px-6 py-3 rounded-full font-semibold flex items-center gap-2 hover:bg-gray-100 transition-colors duration-200">
          <Gift size={20} />
          Refer your friends
        </button> */}
      </div>
    </div>
  );
};